import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)



export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonSpinnerComponent',
  props: {
    visible: Boolean
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (props.visible)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _hoisted_1,
        _hoisted_2
      ], 64))
    : _createCommentVNode("", true)
}
}

})